<template>
  <nav class="navbar navbar-expand-lg sticky-top">
    <!-- Brand logo -->
    <a class="navbar-brand nav-image-container" href="https://muvve.com" target="_blank">
      <img src="../assets/images/muvve_logo_white.png" class="d-inline-block align-top nav-image">
    </a>

    <template v-if="loggedIn">
      <!-- Hamburger collapse for narrow screens -->
      <button class="navbar-toggler navbar-dark" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Nav links. Note that <router-links> render as <a> tags, so the styles below apply to these router links -->
      <div class="collapse navbar-collapse ml-1" id="navbarNav">
        <ul class="navbar-nav mr-auto">
          <li v-for="route in routes" :key="route.name" class="nav-item">
            <router-link :to="route.path" :exact="route.exact" class="nav-item nav-link">{{ route.name }}</router-link>
          </li>
        </ul>
        <ul class="navbar-nav my-3">
          <li class="nav-item">
            <router-link to="/settings" class="nav-item nav-link mr-3">Settings</router-link>
          </li>
          <li class="nav-item">
            <button type="button" class="btn btn-lg btn-outline-light my-2 my-sm-0 ml-auto mr-4" @click="$emit('logout')">Log Out</button>
          </li>
        </ul>
      </div>
    </template>
  </nav>
</template>

<script>
export default {
  computed: {
    routes () {
      let sharedRoutes = [
        { name: 'Home', path: '/home', exact: true },
        { name: 'Add Event', path: '/event/add' }
      ]

      let userRoutes
      if (this.isAdmin) {
        const manageHostsRoute = { name: 'Manage Hosts', path: '/admin/manage-hosts' }
        const metricsRoute = { name: 'Metrics', path: '/admin/metrics' }
        userRoutes = [manageHostsRoute, metricsRoute]
      } else {
        const paymentsRoute = { name: 'Payments', path: '/payments' }
        userRoutes = [paymentsRoute]
      }

      return sharedRoutes.concat(userRoutes)
    }
  }
}
</script>

<style scoped>
.navbar.sticky-top {
  background-color: var(--Muvve-black);
}

.nav-image-container {
  max-width: 200px;
  margin-top: 10px;
}

.nav-image {
  width: 90%;
}

a.nav-item.nav-link {
  color: rgb(255, 255, 255);
  font-size: 130%;
}

a.nav-item.nav-link.router-link-active {
  color: #bababa ;
}
</style>
